module.exports = ".nodata{\r\n    margin-top: 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/opc/shared/components/cardview/cardview.component.css
// module id = ./src/opc/shared/components/cardview/cardview.component.css
// module chunks = main